import React, { MouseEvent } from 'react';

type SelectedOptionLabelProps = {
  id: string;
  onLabelClick: (event: MouseEvent) => void;
  value: string;
};

const SelectedOptionLabel: React.VFC<SelectedOptionLabelProps> = ({
  onLabelClick,
  value,
  id,
}) => {
  const isMultiple = value === 'Multiple Groups';
  const isMultipleAssignee = value === 'Multiple Assignees';
  return (
    <div
      data-testid={id}
      style={{
        backgroundColor: isMultipleAssignee
          ? 'rgba(167, 63, 142, 0.1)'
          : isMultiple
          ? 'rgba(167, 63, 142, 0.1)'
          : 'rgba(0, 116, 204, 0.1)',
        borderRadius: '0.5rem',
        display: 'inline-flex',
        margin: '2px',
        maxWidth: '214px',
        minWidth: '0px',
        overflow: 'hidden',
        boxSizing: 'border-box',
        padding: '0.5rem',
      }}
    >
      <div
        style={{
          borderRadius: '2px',
          color: isMultipleAssignee
            ? 'rgba(167, 63, 142, 1)'
            : isMultiple
            ? 'rgba(167, 63, 142, 1)'
            : 'rgb(0, 116, 204)',
          fontSize: '14px',
          overflow: 'hidden',
          padding: '3px 3px 3px 6px',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          boxSizing: 'border-box',
        }}
      >
        {value}
      </div>
      <div
        onClick={(event: MouseEvent) => onLabelClick(event)}
        data-testid={`${id}-remove-btn`}
        style={{
          alignItems: 'center',
          borderRadius: '2px',
          display: 'flex',
          boxSizing: 'border-box',
          color: isMultipleAssignee
            ? 'rgba(167, 63, 142, 1)'
            : isMultiple
            ? 'rgba(167, 63, 142, 1)'
            : 'rgb(0, 116, 204)',
          cursor: 'pointer',
          padding: '0px 0px 0px 8px',
        }}
      >
        <svg
          height={isMultipleAssignee ? '20' : '14'}
          width={isMultipleAssignee ? '20' : '14'}
          viewBox="0 0 20 20"
          aria-hidden="true"
          focusable="false"
          stroke={isMultipleAssignee ? 'rgb(229, 241, 250)' : ''}
        >
          <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" />
        </svg>
      </div>
    </div>
  );
};

export default SelectedOptionLabel;
